import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ToolsService} from '../../tools/tools.service';

@Injectable({
  providedIn: 'root'
})

export class LangagesService {
  currLang: BehaviorSubject<any> = new BehaviorSubject(null);

  langAccepted = ["en", "fr", "es"];

  constructor(
    private translate: TranslateService,
    private tools: ToolsService
  ) {
  }

  get getCurrLang(): Observable<string> {
    return this.currLang.asObservable();
  }

  setDefaultFromLocal() {
    let shortLang = this.getInternetLang();
    let langStore: any = this.tools.getStor("lang") ? this.tools.getStor("lang") : shortLang;
    // langStore = "fr"
    this.setLang(langStore);
  }

  setCurrlang(lang: string) {
    this.currLang.next(lang);
    this.tools.setStor("lang", lang);
    this.translate.use(lang);
  }

  setLang(lang: string) {
    this.currLang.next(lang);
    this.translate.setDefaultLang(lang);
    this.tools.setStor("lang", lang);
  }

  getLang() {
    return this.translate.getDefaultLang();
  }

  getInternetLang() {
    let lang = window.navigator.languages ? window.navigator.languages[0] : null;
    lang = lang || window.navigator.language
    let shortLang = lang;
    if (shortLang.indexOf('-') !== -1) {
      shortLang = shortLang.split('-')[0];
    }


    let lang_acc = this.langAccepted.filter((value) => shortLang == value);
    shortLang = lang_acc && lang_acc.length > 0 ? lang_acc[0] : "fr";


    return shortLang;

  }

  getmeta(lang: any) {
    // lang = 'fr';
    let metaTitle: any = [
      {
        lang: "fr",
        online: "| Commandez en ligne | Fülle Webshop",
        ordernow: "Commandez dès à présent chez ",
        img: "Ceci est une image de prévisualisation du site",
        thankorder: "Merci de votre commande"
      },
      {
        lang: "es",
        online: "| Haga su pedido en línea | Fülle Webshop",
        ordernow: "Haga su pedido ahora en ",
        img: "Esta es una imagen de vista previa del sitio",
        thankorder: "Gracias por su pedido"
      },
      {
        lang: "en",
        online: "| Order online | Fülle Webshop",
        ordernow: "Order now at",
        img: "This is a preview image of the site",
        thankorder: "Thank you for your order"
      },

    ];

    return metaTitle.find((value: any) => value.lang == lang) ? metaTitle.find((value: any) => value.lang == lang) : metaTitle[0];
  }
}
